import { PAYTM_CITY_SEARCH_DATA } from './actionTypes'

const initialState = {
  cityData: [],
}

export default (state = initialState, { type, payload }) => {
  switch(type) {
    case PAYTM_CITY_SEARCH_DATA: {
      return {
        ...state,
        cityData: payload.data,
      }
    }
    default: 
      return state
  }
}
